import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'

const headerWrapper: CSSObject = {
  borderBottom: '0.5px solid #ddd',
  padding: '14px 0 0 14px',
  ul: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    listStyleType: 'none',
    margin: 0,
    textAlign: 'center',
  },
}

const profile: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  marginBottom: '13px',
  ul: {
    lineHeight: '17px',
    padding: '0 22px 0 43px',
    width: '210px',
  },
  li: {
    fontSize: fontSizes.medium,
  },
}

const account: CSSObject = {
  fontWeight: fontWeights.bold,
}

const boldText: CSSObject = {
  fontWeight: fontWeights.bold,
}

const buttonWrapper: CSSObject = {
  display: 'flex',
  margin: '20px 0 20px 2px',
  ul: {
    padding: 0,
  },
  li: {
    alignItems: 'center',
    borderRadius: '4px',
    display: 'flex',
    fontSize: fontSizes.large,
    fontWeight: fontWeights.bold,
    height: '18px',
    justifyContent: 'center',
    marginRight: '5px',
    padding: '8px 0 8px 0',
    '&.kuiper-igtv-blue-theme-btn': {
      backgroundColor: '#0095f6',
      color: 'white',
      width: '150px',
    },
    '&.kuiper-igtv-light-theme-btn': {
      border: '1px solid #dadbda',
      width: '148px',
    },
    '&.kuiper-igtv-icon-btn': {
      width: '32px',
    },
  },
}

const tabWrapper: CSSObject = {
  ul: {
    padding: 0,
  },
  li: {
    height: '29px',
    width: '125px',
    '.kuiper-icon-wrapper': {
      color: '#6d6d6d',
    },
    '&.kuiper-active-tab': {
      borderBottom: '1px solid black',
      '.kuiper-icon-wrapper': {
        color: 'black',
      },
    },
  },
}

const styles = {
  account,
  boldText,
  buttonWrapper,
  headerWrapper,
  profile,
  tabWrapper,
}

export { styles }
